<template>
  <div class="col-md-9 panel panel-default bar-graph"></div>
</template>

<script>
import * as d3 from 'd3'

export default {
  name: 'barChart',
  props: ['data', 'title'],

  mounted () {
    this.loadBarChart()
  },

  methods: {
    loadBarChart () {
      if (this.data) {
        this.generateD3HorizontalBarChart(this.data, this.title, false, false)
      } else {
        $(this.$el).html('No Data Found!')
      }
    },
    generateD3HorizontalBarChart (data, chartYAxisName, isSupportClick, isAnimated) {
      $(this.$el).empty()
      if (data && Object.keys(data).length > 0) {
        let widthOfContainer = window.innerHeight
        let alumniArray = []
        for (var key in data) {
          let details = data[key]
          details.title = key
          alumniArray.push(details)
        }
        alumniArray.sort((a, b) => {
          return b.count - a.count
        })

        let newCanvas = document.createElement('canvas')
        let context = newCanvas.getContext('2d')
        context.font = '12pt Arial'
        let maxTextWidth = 0

        let categories = []
        let dataArray = []
        let maximumValue = 0
        for (var record in alumniArray) {
          let details = alumniArray[record]
          let title = details.title
          let metrics = context.measureText(title)
          let textWidth = metrics.width
          if (textWidth > maxTextWidth) {
            maxTextWidth = textWidth
          }
          categories.push(title)
          let count = details.count
          if (count > maximumValue) {
            maximumValue = count
          }
          dataArray.push(details)
        }
        let maxTextWidthPossible = widthOfContainer * 0.7
        if (maxTextWidth > maxTextWidthPossible) {
          maxTextWidth = maxTextWidthPossible
        }

        // Alas, these lines seem to be needed...
        let reportsSectionHeadingHeight = $('div.reports_section_heading').innerHeight() // Stanford GSB
        if (!reportsSectionHeadingHeight || reportsSectionHeadingHeight < 40) {
          reportsSectionHeadingHeight = 40 // Kenyon
        }
        let heightOfEachBar = 32 // (pixels)
        let spaceBetweenBars = 0 // (pixels)
        let rowHeight = heightOfEachBar + spaceBetweenBars
        let numberOfRows = categories.length // Automatically adjusts
        let width = widthOfContainer - 5 // Total width (pixels)
        let extraBottomPageBorder = 32 + reportsSectionHeadingHeight // Extra space at bottom of screen (pixels)
        let extraRightPageBorder = 6 // Extra space at RHS of screen (pixels)
        let ymax = rowHeight * numberOfRows // Y axis - general scale factor - closely related to height (pixels)
        let xSizeLhs = maxTextWidth // Margin on left hand side of graph (pixels)
        let xSizeRhs = width - xSizeLhs - extraRightPageBorder // X axis - general scale factor (pixels)
        let yOffsetAxisLabel = 8
        let yDeltaBetweenAxisAndChart = rowHeight + 2
        let topAxisOffset = yOffsetAxisLabel + 20
        let extraYoffsetForChart = topAxisOffset - 10 // Vertical displacement for bars - fudge factor (pixels)
        let extraYoffsetForAxes = yDeltaBetweenAxisAndChart + extraYoffsetForChart // Fudge factor (pixels)
        let height = ymax + extraBottomPageBorder + extraYoffsetForChart
        let barTextHeight = spaceBetweenBars + 38 // Bar text, vertical offset (pixels)
        let grid = d3.range(25).map(function (i) { return {'x1': 0, 'y1': (-2 - yDeltaBetweenAxisAndChart), 'x2': 0, 'y2': (ymax + 4)} })
        let tickInterval = this.getTickInterval(maximumValue, xSizeRhs)
        let tickVals = grid.map(function (d, index) { return index * tickInterval })
        maximumValue = this.getNewMaximumValue(maximumValue, tickInterval)
        let xscale = d3.scaleLinear().domain([0, maximumValue]).range([0, xSizeRhs])
        let yscale = d3.scaleLinear().domain([0, categories.length]).range([0, ymax])
        let colorScale = d3.scaleOrdinal().domain(categories).range(d3.schemeSet3)
        let canvas = d3.select(this.$el).append('svg')
          .attr('width', width)
          .attr('height', height)
        let gridInterval = xSizeRhs / maximumValue * tickInterval
        canvas.append('g').attr('id', 'grid')
          .attr('transform', 'translate(' + xSizeLhs + ',' + extraYoffsetForAxes + ')')
          .selectAll('line').data(grid).enter().append('line')
          .attr('x1', function (d, i) { return (i * gridInterval) })
          .attr('y1', function (d) { return d.y1 })
          .attr('x2', function (d, i) { return (i * gridInterval) })
          .attr('y2', function (d) { return d.y2 })
          .style({'stroke': '#CCCCCC', 'stroke-width': '1px'})
        let tickSize = 2
        let xAxis = d3.axisBottom().scale(xscale).tickSize(tickSize).tickValues(tickVals)
        let xAxis2 = d3.axisTop().scale(xscale).tickSize(tickSize).tickValues(tickVals)
        let yAxis = d3.axisLeft().scale(yscale).tickSize(tickSize).tickFormat(function (d, i) { return categories[i] }).tickValues(d3.range(numberOfRows))
        canvas.append('g').attr('transform', 'translate(' + xSizeLhs + ',' + extraYoffsetForAxes + ')').attr('id', 'yaxis').call(yAxis)
        canvas.append('g').attr('transform', 'translate(' + xSizeLhs + ',' + (ymax + extraYoffsetForAxes - tickSize) + ')').attr('id', 'xaxis').call(xAxis)
        canvas.append('g').attr('transform', 'translate(' + xSizeLhs + ',' + (topAxisOffset + 5) + ')').attr('id', 'xaxis2').call(xAxis2)

        let clickFunction = (d) => {
          if (isSupportClick) {
            console.log('click supported')
          } else {
            console.log('click not supported')
          }
        }

        let rectClass = isSupportClick ? 'isSupportClick' : 'isNoClick'
        canvas.append('g')
          .attr('transform', 'translate(' + xSizeLhs + ', ' + extraYoffsetForChart + ')')
          .attr('id', 'bars')
          .selectAll('rect').data(dataArray).enter().append('rect')
          .attr('class', rectClass)
          .attr('height', heightOfEachBar)
          .attr('width', function (d) { return 0 })
          .on('click', clickFunction)
          .attr('x', 0)
          .attr('y', function (d, i) { return yscale(i) + heightOfEachBar / 2 })
          .style('fill', function (d, i) { return colorScale(i) })

        let xAxisText = 'Number of Alumni'
        canvas.append('text')
          .attr('class', 'x label bottom')
          .attr('text-anchor', 'end')
          .attr('x', (width - extraRightPageBorder - 100) * 8 / 10)
          .attr('y', ymax + extraYoffsetForAxes + 35)
          .text(xAxisText)

        canvas.append('text')
          .attr('class', 'x label top')
          .attr('text-anchor', 'end')
          .attr('x', (width - extraRightPageBorder - 100) * 8 / 10)
          .attr('y', (yOffsetAxisLabel + 7))
          .text(xAxisText)

        if (ymax > 140) {
          canvas.append('text')
            .attr('class', 'y label')
            .attr('text-anchor', 'end')
            .attr('transform', 'rotate(-90)')
            .attr('y', 15)
            .attr('x', 0 - (ymax / 2))
            .text(chartYAxisName)
        }

        // handles animation of bars...
        if (isAnimated) {
          d3.select(this.$el).select('svg').selectAll('rect')
            .data(dataArray).transition().duration(500)
            .attr('width', function (d) { return xscale(d.count) })
        } else {
          d3.select(this.$el).select('svg').selectAll('rect')
            .data(dataArray).attr('width', function (d) { return xscale(d.count) })
        }
        // handles text on bars...
        d3.select(this.$el).select('#bars').selectAll('text')
          .data(dataArray).enter().append('text')
          .attr('class', 'bar-text label')
          .attr('x', function (d) { return 5 })
          .attr('y', function (d, i) { return yscale(i) + barTextHeight })
          .text(function (d) { return d.count + '' })
          .style({'fill': '#D0D0D0', 'font-size': '14px'})
      } else {
        $(this.$el).html('No Data Found!')
      }
    },
    getTickInterval (count, xSizeInPixels) {
      let xSizeInPixelsMin = 10
      if (xSizeInPixels < xSizeInPixelsMin) {
        xSizeInPixels = xSizeInPixelsMin
      }
      let size = count * 500 / xSizeInPixels
      if (size < 15) {
        return 1
      } else if (size < 30) {
        return 2
      } else if (size < 75) {
        return 5
      } else if (size < 150) {
        return 10
      } else if (size < 300) {
        return 20
      } else if (size < 750) {
        return 50
      } else if (size < 1300) {
        return 100
      } else if (size < 2500) {
        return 200
      } else if (size < 5000) {
        return 500
      } else if (size < 10000) {
        return 1000
      } else if (size < 15000) {
        return 1500
      } else if (size < 25000) {
        return 2000
      }
      return 2500
    },
    getNewMaximumValue (maximumValue, tickInterval) {
      let n = Math.floor(maximumValue / tickInterval)
      return (n + n + 1) * tickInterval / 2
    }
  }
}
</script>

<style>
  .label {
    font-size: 14px;
  }

  .bar-graph {
    display: inline-block;
    overflow-x: auto;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/app/explore/components/BarChart.vue